





























































































































































































































































































































import Vue from 'vue';
import config from '@/config/index';
import HandleErrors from '@/config/handleErrors';
import Confirmation from '@/components/Confirmation.vue';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy, EstadoEntidad } from '@/config/enums';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';
import { differenceBy } from 'lodash';
import {
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  CellContextMenuEvent,
} from 'ag-grid-community';
import { Funcionalidades } from '@/config/funcionalidades';
import { PermisoAccionVm } from '@/views/base/PermisoAccionVm';
import { ComponenteBaseStepper } from '@/views/base/ComponenteBaseStepper';
import { Contacto } from '@/pantallas/Contactos/Contacto';
import { ITipoContacto } from '../../interfaces/TipoContacto';
import { EstadosService } from '@/services/estadosService';
import { EstadoInterface } from '@/interfaces/Estado';
import { ListaDistribucion } from '../../pantallas/ListaDistribucion/ListaDistribucion';
import { CodigoAccion } from '@/views/base/VariablesPermisos';

const { AgGridVue } = require('ag-grid-vue');

@Component({
  components: {
    'ag-grid-vue': AgGridVue,
    'app-confirmacion': Confirmation,
  },
})
export default class ContactoModalEdicion extends ComponenteBaseStepper {
  @Prop({ default: false }) show!: boolean;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: () => ({ id: 0 }) }) contacto!: Contacto;

  //permisos
  funcionalidad: Funcionalidades = Funcionalidades.Contactos;
  permisosActuales: PermisoAccionVm[] = [];

  informacionGeneral: PermisoAccionVm = {
    accion: 'Editar - Información General',
    visible: true,
    step: 1,
    codigoSubAccion: 19,
    codigoAccionPadre: CodigoAccion.Editar,
  };

  asociarLista: PermisoAccionVm = {
    accion: 'Editar - Asociar Lista de Distribución',
    visible: true,
    step: 2,
    codigoSubAccion: 58,
    codigoAccionPadre: CodigoAccion.Editar,
  };

  informacionGeneralVerDetalle: PermisoAccionVm = {
    accion: 'Ver Detalle - Información General',
    visible: true,
    step: 1,
    codigoSubAccion: 19,
    codigoAccionPadre: CodigoAccion.VerDetalle,
  };

  asociarListaVerDetalle: PermisoAccionVm = {
    accion: 'Ver Detalle - Asociar Lista de Distribución',
    visible: true,
    step: 2,
    codigoSubAccion: 58,
    codigoAccionPadre: CodigoAccion.VerDetalle,
  };

  permisosTotales: PermisoAccionVm[] = [
    this.informacionGeneral,
    this.asociarLista,
    this.informacionGeneralVerDetalle,
    this.asociarListaVerDetalle,
  ];

  //controller
  readonly Controller: string = 'Contactos';

  $snotify: any;
  btnText: string = 'Continuar';
  dialog: boolean = false;
  validForm: boolean = false;
  editedItem: Contacto = {};
  dictionaryFormErrors: any = {};
  bottomNav: any = '1';
  dialogConfirmacion: boolean = false;
  dialogConfirmacionClose: boolean = false;
  handleErrors: HandleErrors = new HandleErrors();
  btnBloquear: boolean = false;
  axios: AxiosVue = new AxiosVue(ServicioProxy.Contacto);
  clienteId: number = config.getClienteSesion();
  loadingService = new LoadingService();

  //Data
  tiposContacto: ITipoContacto[] = [];
  warningInactivo: any = '';
  guardarInactivo: boolean = false;
  mensajeConfirmacionInactivo: any = '';
  estado: boolean = true;
  sideBar: any = config.agGridDefaultConfig;

  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  listasAsignados: ListaDistribucion[] = [];
  listasRespaldo: ListaDistribucion[] = [];
  localeText: any = config.agGridTextos;
  buscaListaEditar: string = '';

  @Watch('show')
  async onPropertyChanged(value: boolean, oldValue: boolean) {
    this.dialog = value;
    this.btnText = 'Continuar';
    this.bottomNav = '1';
    this.$validator.reset();

    // permisos
    this.chequearPermisosEditarDetalle();
    this.setBotonNav();

    if (value) {
      this.loadingService.showLoading();
      this.editedItem = this.contacto;
      this.estado = this.editedItem.estado === 1 ? true : false;
      await this.getTipoContacto();
      await this.getListasDistribucion();
      this.selectedEstado(this.estado);
      this.initialize();
      this.btnBloquear = false;
      this.editedItem.listaDistribucionId;
      await this.seteaAsignados();
      this.loadingService.hideLoading();
    }
  }

  setBotonNav() {
    var accion = 'Editar';
    var evaluado = false;

    if (!this.esEdicion) {
      accion = 'Ver Detalle';
    }
    this.permisosTotales.forEach(obj => {
      if (obj.visible && obj.accion.includes(accion) && !evaluado) {
        this.bottomNav = obj.step;
        evaluado = true;
      }
    });
  }

  grabarEdicion() {
    this.$validator.validateAll().then(res => {
      if (res) {
        this.dialogConfirmacion = true;
        this.btnBloquear = false;
      }
    });
  }

  async confirmCallback(val: boolean) {
    this.dialogConfirmacion = false;

    if (val) {
      this.loadingService.showLoading();
      try {
        this.editedItem.estado = 1;
        this.editedItem.listaDistribucionId = this.listasAsignados.map(
          lista => lista.id
        );
        this.axios.http
          .put(
            `${this.Controller}/${config.getClienteSesion()}`,
            this.editedItem
          )
          .then(contacto => {
            this.$snotify.success(this.$t('mensajes.mensajesExito.editar'));
            this.closeModal(false);
          })
          .catch(error => {
            this.$snotify.error(this.$t('mensajes.mensajesError.editar'));
          });
      } finally {
        this.loadingService.hideLoading();
      }
    }
    this.btnBloquear = false;
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }

  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }

  closeModal(val: boolean) {
    document.getElementById('cardDivRT').scrollIntoView(true);
    this.btnBloquear = false;
    this.editedItem = {};
    this.buscaListaEditar = '';
    //this.gridApi.setQuickFilter('');
    this.$emit('modalAsociacionEmit', false);
    this.dialog = false;
    this.warningInactivo = ' ';
    this.estado = true;
    this.listasAsignados = [];
    this.listasRespaldo = [];
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
  }

  initialize() {
    this.columnDefs = [
      {
        headerName: '',
        field: 'checked',
        width: 70,
        minWidth: 70,
        pinned: 'left',
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        suppressMenu: true,
        resizable: true,
        sortable: true,
        sort: 'desc',
        filter: false,
        suppressMovable: true,
        lockVisible: true,
        cellStyle: { textAlign: 'left' },
        cellRenderer: (r: any) => {
          if (r.data.checked) {
            return r.node.setSelected(r.data.checked);
          }
        },
      },
      {
        headerName: 'Código',
        field: 'id',
        resizable: true,
        sortable: true,
        lockPinned: true,
        minWidth: 80,
        hide: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Nombre',
        field: 'nombre',
        width: 200,
        minWidth: 80,
        lockPinned: true,
        resizable: true,
        sortable: true,
        lockVisible: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Descripción',
        field: 'descripcion',
        width: 200,
        minWidth: 80,
        lockPinned: true,
        resizable: true,
        sortable: true,
        lockVisible: true,
        cellStyle: { textAlign: 'left' },
      },
    ];

    this.dictionaryFormErrors = {
      custom: {
        cia: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
        },
        numSim: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
          numeric: config.errorMensajes.soloNumeros,
        },
        tipoSim: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
        },
        numeroTelefonico: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
          regex: config.errorMensajes.regex,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);

    if (!this.esEdicion) {
      this.columnDefs.shift();
    }
  }

  onClickCell(params: CellContextMenuEvent) {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 1) {
      appBanners[0].remove();
    }
  }

  getRowNodeId(lista: any) {
    if (!lista) {
      return;
    }
    return lista.id;
  }

  onSelectionChanged() {
    this.listasAsignados = this.gridApi.getSelectedRows();
    const listasSeleccionados = this.gridApi
      .getSelectedNodes()
      .map(node => ({ ...node.data, checked: true }));

    const listasNoSeleccionados = differenceBy(
      this.listasRespaldo,
      listasSeleccionados,
      lista => lista.id
    ).map(lista => ({
      ...lista,
      checked: false,
    }));
    this.gridApi.updateRowData({
      update: [...listasNoSeleccionados, ...listasSeleccionados],
    });
  }

  onFilterTextBoxChangedGpsEditar() {
    if (this.buscaListaEditar.length > 1) {
      this.gridApi.setQuickFilter(this.buscaListaEditar);
    } else {
      this.gridApi.setQuickFilter('');
    }
  }

  async getTipoContacto() {
    try {
      const response = await this.axios.http.get(
        `${this.Controller}/${this.editedItem.tipoContactoId}/${this.clienteId}/tiposContacto`
      );
      this.tiposContacto = response.data;
    } catch (error) {
      this.loadingService.hideLoading();
      if (error.response !== undefined) {
        if (error.response.status !== 401) {
          this.handleErrors.showError(error);
        }
      } else {
        this.handleErrors.showError(error);
      }
    }
  }

  selectedEstado(isActivo: boolean) {
    if (!isActivo) {
      this.guardarInactivo = true;

      this.warningInactivo =
        'Al dejar como inactivo, no se podrán realizar asociaciones.';
      this.mensajeConfirmacionInactivo =
        this.warningInactivo +
        ' ' +
        this.$t('mensajes.crud.editar.mensaje', {
          entidad: 'el Contacto',
        });
    } else {
      this.warningInactivo = '';
      this.guardarInactivo = false;
      this.mensajeConfirmacionInactivo = this.$t(
        'mensajes.crud.editar.mensaje',
        { entidad: 'el Contacto' }
      );
    }
  }

  async getListasDistribucion() {
    const res: any = await this.axios.http.get(
      `ListaDistribucionB/listaDistribucionActivas/${config.getClienteSesion()}`
    );
    this.listasRespaldo = res.data;
  }

  seteaAsignados() {
    this.listasRespaldo.forEach(lista => {
      let id = this.editedItem.listaDistribucionId.find(id => id === lista.id);
      if (id) {
        this.listasAsignados.push(lista);
        lista.checked = true;
      } else {
        lista.checked = false;
      }
    });

    if (!this.esEdicion) {
      this.listasRespaldo = this.listasAsignados;
    }
  }
}
